/**
 * @function getCoordinates - Получает координаты станций по маршруту поезда
 * @param {array} points - список остановочных пунктов
 * @return array
 * */

export default function getCoordinates(points) {
    const coords = [];

    for (let i = 0; i < points.length; i++) {
        const { latitude, longitude } = points[i];

        coords.push([latitude, longitude]);
    }

    return coords;
}
